
<!-- CARRUSEL DE IMAGENES QUE SE MUESTRA CAMBIANDO -->
<app-main-carousel [slides]="slides"></app-main-carousel> 
<!-- TERMINA CARRUSEL -->


<div fxLayout="row wrap" class="mt-2">
    <div fxFlex="100" fxFlex.gt-md="100" fxFlex.md="100">
        <!-- <mat-card> 
            <editor [inline]="true" [disabled]="true" apiKey="rv7qtvpvfahwshq6y14lp4gflvg20fwiiov7gjchqtjjjmhh"
						[init]="{
							height: 500,
							menubar: false,
							plugins: [
							],
							toolbar:
							  ''
						  }"
						[(ngModel)]="description" >
						</editor>
           
        </mat-card> -->
        <div class="Rectngulo_3" >
            <div fxLayout="column" fxLayoutAlign="center center" class="content" id="How_It_Works">How It Works</div>
        </div>
        
        <div fxLayout="column" fxLayoutAlign="center center" >
            <hr class="line">
        </div>
       
        

    </div>

    <div fxFlex="100" fxFlex.gt-md="33.3" fxFlex.md="33.3">

        <div id="Componente_1__1" class="Componente_1___1">
            <div    id="We_Curate_The_Worlds_Best_Coff">We Curate The World&rsquo;s Best Coffee<br /><br /><span style="font-style: normal; font-weight: lighter; color: rgba(155,155,155,1);">A coffee of the month club that curates amazing micro-lot coffees from around the world.<br />Tanzania, Kenya, Colombia &amp; beyond.<br /><br /><br /></span></div>
        </div>

    </div>

    <div fxFlex="100" fxFlex.gt-md="33.3" fxFlex.md="33.3">

        <div    id="A_World_Tour_Of_Amazing_Coffee">A World Tour Of Amazing Coffee&reg;<br /><span style="font-style: normal; font-weight: lighter; color: rgba(155,155,155,1);"><br />Think of us as your coffee tour guides, sending you amazing &amp; exotic coffees you can&rsquo;t find anywhere online or on the shelf.<br /><br /><br /><br /></span></div>

    </div>

    <div fxFlex="100" fxFlex.gt-md="33.3" fxFlex.md="33.3">
        
        <div  id="__Roasted_Fresh__Delivered_To_"><span style="font-style: normal; font-weight: normal; color: rgba(107,107,107,1); letter-spacing: 1px;">Roasted Fresh &amp; Delivered To You<br /></span><br />Each month features 12 ounces of freshly roasted coffee, flavor notes, a postcard, and brewing tips.<br /><br /></div>

    </div>

    

    
</div>
<div fxLayout="row wrap" >
    <div fxFlex="100" fxFlex.gt-md="100" fxFlex.md="100">
        <div fxLayout="column" fxLayoutAlign="center center" class="content">
            
             <button style="font-size: 20px;" class="planButton" (click)="products()" mat-raised-button color="primary" >Planes</button>  
        </div> 
    </div>
</div>

<!-- 
<div fxLayout="row wrap" class="mt-2">
    <div fxFlex="100" fxFlex.gt-md="100" fxFlex.md="100">
        <div fxLayout="column" fxLayoutAlign="center center" class="content">
            <div id="How_It_Works">How It Works</div> 
        </div> 
    </div>
</div>
-->
